import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { http } from "@/lib/api";
import { useBranding } from "@/lib/branding";
import { LandingView } from "@/components/branding/LandingView";
import { JoinModal } from "@/components/branding/JoinModal";
import { useForceDark } from "@/context/ThemeContext";

export default function Landing() {
  useForceDark();
  const navigate = useNavigate();
  const branding = useBranding();
  const [join, setJoin] = useState(false);
  const { data: plansData } = useQuery({
    queryKey: ["public-plans"],
    queryFn: async () => (await http.get("/public/plans")).data,
    staleTime: 0,
  });

  const onJoin = () => {
    if (branding?.public_registration) navigate("/login");
    else setJoin(true);
  };

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="public-landing">
      <LandingView branding={branding} plans={plansData?.plans || []} onLogin={() => navigate("/login")} onJoin={onJoin} />
      <JoinModal branding={branding} open={join} onClose={() => setJoin(false)} />
    </div>
  );
}
